"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var filterLink_styles_1 = require("./filterLink.styles");
var arrowDown_icon_1 = require("../../../icons/arrow/arrowDown.icon");
exports.FilterLink = function (props) {
    var value;
    if (props.filterCount !== undefined && props.totalFilters !== undefined) {
        value = props.selectedValue ? props.selectedValue : null;
    }
    else {
        value = props.selectedValue !== undefined ? props.selectedValue : props.defaultValue;
    }
    var linkContainerClass = props.isShowingOptions
        ? filterLink_styles_1.getLinkContainerActive()
        : filterLink_styles_1.getLinkContainer(props.borderless ? "#ffffff" : "#b7bbbd");
    var linkClass = props.isMulti ? filterLink_styles_1.linkMulti : filterLink_styles_1.link;
    return (React.createElement("div", { className: linkContainerClass + " " + (props.disabled && filterLink_styles_1.disabled), id: props.id + "-wrapper", "data-qa": "filterLink", "data-qa-disabled": props.disabled },
        props.filterText && React.createElement("span", { className: filterLink_styles_1.text },
            props.filterText,
            ": "),
        React.createElement("span", { className: linkClass, id: props.id + "-selected" },
            value,
            props.filterCount !== undefined ? (React.createElement(exports.FilterText, { selected: props.filterCount, total: props.totalFilters })) : null),
        React.createElement(arrowDown_icon_1.ArrowDownIcon, { disabled: props.disabled })));
};
exports.FilterText = function (props) {
    if (props.selected === props.total || props.selected === 0) {
        return (React.createElement("span", { "data-testid": "filter-count" },
            "All (",
            props.selected !== 0 ? props.selected : props.total,
            ")"));
    }
    else {
        return (React.createElement("span", { "data-testid": "filter-count" },
            props.selected,
            " of ",
            props.total));
    }
};
